import React, { Component }  from 'react';
import { Button, Paper, Grid } from '@material-ui/core';
import * as OrderStepStatus from '../constants/OrderStepStatus';
import StopModal from './orderStepInfo/StopModal';
import StartModal from './orderStepInfo/StartModal';
import ScanModal from './orderStepInfo/ScanModal';
import { useTranslation, Trans } from 'react-i18next';
import { toast } from 'react-toastify';
import { SETSCANMODE, STARTPRODUCTIONORDERSTEP, STOPPRODUCTIONORDERSTEP, STOPPRODUCTIONORDERSTEPWITHQUANTITY, SCANPRODUCTIONORDERSTEP, SCANPRODUCTIONORDERSTEPWITHPIECENUMBER } from '../constants/Config';
const { t } = useTranslation();

class OrderStepInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stopDialogOpen: false,
            startDialogOpen: false,
            scanDialogOpen: false,
            tracing: 1,
            partBased: false,
            scanAmount: 0,
            statusEnum: 0
          };
        this.openStopModal = this.openStopModal.bind(true);
        this.openStartModal = this.openStartModal.bind(true);
        this.openScanModal = this.openScanModal.bind(true);
        this.stopOrderStep = this.stopOrderStep.bind(this);
        this.handleChangeTracing = this.handleChangeTracing.bind(this);
        this.handleCloseStopDialog = this.handleCloseStopDialog.bind(this);
        this.handleCloseStartDialog = this.handleCloseStartDialog.bind(this);
        this.handleCloseScanDialog = this.handleCloseScanDialog.bind(this);
        this.handleScanModalCancel = this.handleScanModalCancel.bind(this);
        this.handleStopModalCancel = this.handleStopModalCancel.bind(this);
        this.handleStartModalCancel = this.handleStartModalCancel.bind(this);
    }

    componentDidMount() {
        //TODO find more efficient way to handle this
        switch(this.props.status){
            case "Undefined":
                this.setState({ statusEnum: OrderStepStatus.Status.Undefined });
                break;
            case "New":
                this.setState({ statusEnum: OrderStepStatus.Status.New });
                break;
            case "Started":
                this.setState({ statusEnum: OrderStepStatus.Status.Started });
                break;
            case "Stopped":
                this.setState({ statusEnum: OrderStepStatus.Status.Stopped });
                break;
            case "Ongedefinieerd":
                this.setState({ statusEnum: OrderStepStatus.Status.Undefined });
                break;
            case "Nieuw":
                this.setState({ statusEnum: OrderStepStatus.Status.New });
                break;
            case "Gestart":
                this.setState({ statusEnum: OrderStepStatus.Status.Started });
                break;
            case "Gestopt":
                this.setState({ statusEnum: OrderStepStatus.Status.Stopped });
                break;
            default :
                this.setState({ statusEnum: OrderStepStatus.Status.Undefined });
                break;
          }

          this.setState({ scanAmount: this.props.QuantityActiveRun });
          if(this.props.canScan) {
            this.setState({ tracing: "2" }); // scan by piece
          } else {
            this.setState({ tracing: "1" }); // scan by batch
          }
    }

    handleChangeTracing(event) {
        //TODO set tracing value in an enum
        this.setState({ tracing: event.target.value});
    }

    handleCloseStopDialog = () => {
        this.setState({ stopDialogOpen: false });
        this.setState({ statusEnum: OrderStepStatus.Status.Stopped });
    };

    handleCloseStartDialog = () => {
        this.setState({ startDialogOpen: false });
        this.setState({ statusEnum: OrderStepStatus.Status.Started });
    };

    handleScanModalCancel = () => {
        this.setState({ scanDialogOpen: false });
    }

    handleStartModalCancel = () => {
        this.setState({ startDialogOpen: false });
    }

    handleStopModalCancel = () => {
        this.setState({ stopDialogOpen: false });
    }

    handleCloseScanDialog = (partNumber) => {
        fetch(SCANPRODUCTIONORDERSTEPWITHPIECENUMBER + this.props.id + "/" + partNumber + "/" + 1, {method: 'GET'})
        .then((response) => {
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                if (!response.ok) {
                    const error = (data && data.message) || response.statusText;
                    toast.error(error, {
                        position: toast.POSITION.TOP_CENTER
                      });
                    return Promise.reject(error);
                }
        
                return data;
            });
        })
        .then((res) => {
            if(res.succeeded === false) {
                for (let index = 0; index < res.messages.length; index++) {
                    toast.error(res.messages[index], {
                        position: toast.POSITION.TOP_CENTER
                      });
                }
                return Promise.reject();
            }
            this.props.getProductionOrderSteps();
            this.setState({ scanDialogOpen: false });
            return true;
        })
        .catch(function(error) {
            toast.error(error, {
                position: toast.POSITION.TOP_CENTER
              });
        });
        
    };

    openStopModal = () => {
        if(this.state.tracing !== "2") {
            this.setState({ stopDialogOpen: true });
        } else {
            this.stopOrderStep(this.state.scanAmount);
        }
    }

    openStartModal = () => {
        if(this.props.needsMachineSettingsScan === true) {
            this.setState({ startDialogOpen: true });
        } else {
            this.startOrderStep();
        }
    }

    openScanModal = () => {
        this.setState({ scanDialogOpen: true });
    }

    stopOrderStep = (amountProduced) => {
        if(this.props.needsMachineSettingsScan) {
            this.scanOrderStep();
        }

        fetch(STOPPRODUCTIONORDERSTEPWITHQUANTITY + this.props.id + "/" + amountProduced, {method: 'GET'}) // TODO: no amount: take other api call (by piece logic)
        .then((response) => {
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                if (!response.ok) {
                    const error = (data && data.message) || response.statusText;
                    toast.error(error, {
                        position: toast.POSITION.TOP_CENTER
                      });
                    return Promise.reject(error);
                }

                return data;
            });
        })
        .then((res) => {
            if(res.succeeded === false) {
                for (let index = 0; index < res.messages.length; index++) {
                    toast.error(res.messages[index], {
                        position: toast.POSITION.TOP_CENTER
                      });
                }
                return Promise.reject();
            }
            this.props.getProductionOrderSteps();
        })
        .then(() => {
            this.handleCloseStopDialog();
        })
        .catch(function(error) {
            toast.error(error, {
                position: toast.POSITION.TOP_CENTER
              });
        });
    }

    stopOrderStepInByPieceScanningMode = () => {
        fetch(STOPPRODUCTIONORDERSTEP + this.props.id, {method: 'GET'})
        .then((response) => {
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                if (!response.ok) {
                    const error = (data && data.message) || response.statusText;
                    toast.error(error, {
                        position: toast.POSITION.TOP_CENTER
                      });
                    return Promise.reject(error);
                }

                return data;
            });
        })
        .then((res) => {
            if(res.succeeded === false) {
                for (let index = 0; index < res.messages.length; index++) {
                    toast.error(res.messages[index], {
                        position: toast.POSITION.TOP_CENTER
                      });
                }
                return Promise.reject();
            }
            this.props.getProductionOrderSteps();
        })
        .then(() => {
            this.handleCloseStopDialog();
        })
        .catch(function(error) {
            toast.error(error, {
                position: toast.POSITION.TOP_CENTER
              });
        });
    }

    startOrderStep = () => {
        fetch(STARTPRODUCTIONORDERSTEP + this.props.id, {method: 'GET'})
        .then((response) => {
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                if (!response.ok) {
                    const error = (data && data.message) || response.statusText;
                    toast.error(error, {
                        position: toast.POSITION.TOP_CENTER
                      });
                    return Promise.reject(error);
                }

                return data;
            });
        })
        .then((res) => {
            if(res.succeeded === false) {
                for (let index = 0; index < res.messages.length; index++) {
                    toast.error(res.messages[index], {
                        position: toast.POSITION.TOP_CENTER
                      });
                }
                return Promise.reject();
            }
            this.props.getProductionOrderSteps();
            return true;
        })
        .then(() => {
            this.setState({ scanAmount: 0});
            this.handleCloseStartDialog();

            if(this.props.needsMachineSettingsScan === true) {
                fetch(SETSCANMODE + "/" + this.props.id + "/" + this.state.tracing, {method: 'GET'})
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);
                        if (!response.ok) {
                            const error = (data && data.message) || response.statusText;
                            toast.error(error, {
                                position: toast.POSITION.TOP_CENTER
                              });
                            return Promise.reject(error);
                        }
        
                        return data;
                    });
                })
                .then((res) => {
                    if(res.succeeded === false) {
                        for (let index = 0; index < res.messages.length; index++) {
                            toast.error(res.messages[index], {
                                position: toast.POSITION.TOP_CENTER
                              });
                        }
                        return Promise.reject();
                    }
                    return true;
                })
                .catch(function(error) {
                    toast.error(error, {
                        position: toast.POSITION.TOP_CENTER
                      });
                });
            }
        })
        .catch(function(error) {
            toast.error(error, {
                position: toast.POSITION.TOP_CENTER
              });
        });
    }

    scanOrderStep = () => {
        fetch(SCANPRODUCTIONORDERSTEP + this.props.id + "/" + 1, {method: 'GET'})
        .then((response) => {
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                if (!response.ok) {
                    const error = (data && data.message) || response.statusText;
                    toast.error(error, {
                        position: toast.POSITION.TOP_CENTER
                      });
                    return Promise.reject(error);
                }
        
                return data;
            });
        })
        .then((res) => {
            if(res.succeeded === false) {
                for (let index = 0; index < res.messages.length; index++) {
                    toast.error(res.messages[index], {
                        position: toast.POSITION.TOP_CENTER
                      });
                }
                return Promise.reject();
            }
            this.props.getProductionOrderSteps();
            return true;
        })
        .then (() => {
            this.setState({ scanAmount: this.state.scanAmount + 1 });
            this.setState({ scanDialogOpen: false });
        })
        .catch(function(error) {
            toast.error(error, {
                position: toast.POSITION.TOP_CENTER
              });
        });
    }

    totalinfo = () => {
        switch(this.state.statusEnum){
            case OrderStepStatus.Status.Undefined:
                return <div className="TotalInfo"></div>;
            case OrderStepStatus.Status.New:
                return <div className="TotalInfo">
                    </div>;
            case OrderStepStatus.Status.Started:
                return <div className="TotalInfo">
                    <p><Trans>{t('CurrentTime')}</Trans> : {this.props.totalProductionTime}</p>
                    </div>;
            case OrderStepStatus.Status.Stopped:
                return <div className="TotalInfo">
                    <p><Trans>{t('TotalQty')}</Trans> : {this.props.totalQuantity}</p>
                    <p><Trans>{t('TotalTime')}</Trans> : {this.props.totalProductionTime}</p>
                    </div>;
            default :
                return <div className="TotalInfo"></div>;
          }
    }

    stepTile = () => {
        if(this.state.statusEnum !== OrderStepStatus.Status.Undefined) {
            return <Paper className="orderInfoPaper">
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <span className="statusLabel" x-ms-format-detection="none" style={{color: this.props.statusBackground}}>{this.props.status}</span>
                    <p>{this.props.sequence}. {this.props.name}</p>
                    <p>{this.props.resource}</p>
                </Grid>
                <Grid item xs={4}>
                    {this.totalinfo()}
                </Grid>
                <Grid item xs={2}>
                    {this.statusButton()}
                </Grid>
            </Grid>

            <StopModal visible={this.state.stopDialogOpen} handleStopModalCancel={this.handleStopModalCancel} handleCloseStopDialog={this.handleCloseStopDialog} stopOrderStep={this.stopOrderStep}></StopModal>
            <StartModal tracing={this.state.tracing} handleStartModalCancel={this.handleStartModalCancel} visible={this.state.startDialogOpen} handleCloseStartDialog={this.handleCloseStartDialog} startOrderStep={this.startOrderStep} handleChangeTracing={this.handleChangeTracing} ></StartModal>
            <ScanModal visible={this.state.scanDialogOpen} handleScanModalCancel={this.handleScanModalCancel} handleCloseScanDialog={this.handleCloseScanDialog} scanOrderStep={this.scanOrderStep}></ScanModal>
        </Paper>
        } else {
            return <React.Fragment></React.Fragment>
        }
    }

    statusButton = () => {

        if (this.props.canStop === true) {
            if(this.state.statusEnum === OrderStepStatus.Status.Started) {
                if(this.state.tracing === "2") {
                    return <React.Fragment>
                                <Button color="secondary" variant="contained" className="smallNavButton" onClick={this.stopOrderStepInByPieceScanningMode}><Trans>{t('Stop')}</Trans></Button>
                                <Button color="secondary" variant="contained" className="smallNavButton" onClick={this.openScanModal}><Trans>{t('Scan')}</Trans></Button>
                            </React.Fragment>
                } else {
                    return <Button color="secondary" variant="contained" className="navButton" onClick={this.openStopModal}><Trans>{t('Stop')}</Trans></Button>
                }
            } 
        }
        if (this.props.canStart === true) {
            return <Button color="secondary" variant="contained" className="navButton" onClick={this.openStartModal}><Trans>{t('Start')}</Trans></Button>
        } else {
            return <React.Fragment></React.Fragment>
        }
        
    }

    render() {
        return (
            <React.Fragment>
                {this.stepTile()}
            </React.Fragment>
        )
    }
}

export default OrderStepInfo;